import Round from './Round';
import VideoRound from './VideoRound';

export default function roundFactory(round) {
  if (round.video) {
    return new VideoRound(round);
  }
  return new Round(round);
}
